import { PAYMENT_MODULE } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import { useAPIUtils } from "../../useAPIUtils";
import { IPaymentDebitNoteData } from "@/api_framework/api_modals/payment";

AxiosCurlirize(axios, () => {});
type ICartAPIResponse = { status: boolean; message: string };

export const usePaymentDebitNoteDetailsAPI = () => {
  const configuration = useConfiguration();
  const [debitNoteData, setDebitNoteData] = useState<IPaymentDebitNoteData>(null);
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (debit_note_receipt_id: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: ICartAPIResponse = await axios
          .get(`${PAYMENT_MODULE?.DEBIT_NOTE_DETAILS?.baseURL}?debit_note_receipt_id=${debit_note_receipt_id}`, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<any>) => {
            if (res.data.status === true) {
              setDebitNoteData(res.data.data);

              return { status: true, message: "Cart Level Coupons Fetched" };
            } else {
              setDebitNoteData(null);

              return { status: false, message: "No Cart Level Coupons" };
            }
          })
          .catch((e: AxiosError) => {
            setDebitNoteData(null);

            sendCurl(e.config["curlCommand"]);
            captureError(e);

            return { status: false, message: "cart_not_filtered" };
          });
        return response;
      } catch (e: any) {
        setDebitNoteData(null);
        captureError(e);
      }
    },
    [dispatch],
  );
  return { execute, debitNoteData };
};
